import Image, { StaticImageData } from 'next/image';
import { ReactNode } from 'react';
import styles from './team-card.module.css';

export interface ITeamCard {
  name: string;
  prof: string | ReactNode;
  image: StaticImageData;
  imageHover: StaticImageData;
  alt: string;
}

export default function TeamCard({
  alt,
  image,
  imageHover,
  name,
  prof,
}: ITeamCard) {
  return (
    <div className={styles['team-card']}>
      <div className={styles['team-card__image']}>
        <div className={styles['team-card__img']}>
          <Image
            priority
            height={1015}
            width={698}
            src={image?.src}
            alt={alt}
          />
        </div>
        <div className={styles['team-card__img-hover']}>
          <Image
            priority
            height={1015}
            width={698}
            src={imageHover?.src}
            alt={alt}
          />
        </div>
      </div>

      <p className={styles['team-card__name']}>{name}</p>

      <span className={styles['team-card__prof']}>{prof}</span>
    </div>
  );
}
